









import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
@Component({
  components: {}
})
export default class MallUrlSetting extends AbpBase {
  // type 0 基础路径不需要加参数 1 商品详情 2 拼团列表 3 预售列表 4 秒杀列表 5 满X件免一列表 6 满减满折列表 
  // 7 满包邮列表 8 限时折扣列表 9 大转盘 10 刮刮乐 11 积分商品详情 12 文章详情 13 微页面 14 助力领券 15 限时购券 16商品列表
  MallUrlListConfig = [
    { Name: '首页', Value: 'pages/index/index', type: 0 },
    // { Name: '分类页', Value: 'pages/classification/index', type: 0 },
    { Name: '稻田日记', Value: 'pages/discovery/index', type: 0 },
    { Name: '积分商城', Value: 'pages/integral-mall/index', type: 0 },
    { Name: '我的会员卡', Value: 'pages/membership-card/index', type: 0, show: this.isVicutuProject },
    {
      Name: '完善个人资料',
      Value: 'pages/personal-information/index',
      type: 0
    },
    { Name: '卡券兑换', Value: 'pages/cardExchange/index', type: 0 },
    { Name: '券包列表', Value: 'pages/couponPack/index', type: 0 },
    { Name: '余额充值', Value: 'pages/my-account-recharge/index', type: 0 },
    { Name: '视频列表', Value: 'pages/live-list/index', type: 0 },
    { Name: '签到', Value: 'pages/attendance/index', type: 0 },
    { Name: '邀请入会', Value: 'pages/member-invitation/index', type: 0 },
    { Name: '积分兑券', Value: 'pages/takeout/index?type=tostore', type: 0 },
    { Name: '完善个人资料', Value: 'pages/backuppage/backup1', type: 0 },
    { Name: '我的收藏', Value: 'pages/my-collection/index', type: 0 },
    { Name: '附近店铺', Value: 'pages/chooseNearby/index', type: 0 },
    { Name: '我的交易', Value: 'pages/my-trading/index', type: 0, show: this.isVicutuProject },
    { Name: '领券中心', Value: 'pages/receiveCoupon/index', type: 0 },
    { Name: '电子发票', Value: 'pages/invoice/index', type: 0, show: this.isVicutuProject },
    { Name: '问卷列表', Value: 'pages/questionnaire/index', type: 0, show: this.isVicutuProject },

    { Name: '商品分组', Value: 'pages/custom-product-list/index?listConfig=custom', type: 17 },
    { Name: '商品列表', Value: 'pages/standard-product-list/index?listConfig=xiaoyu', type: 16 },
    { Name: '商品详情', Value: 'pages/goods/goods?cartType=0', type: 1 },
    { Name: '积分商品详情', Value: 'pages/goods/goods?cartType=1', type: 11 },
    { Name: '文章详情', Value: 'pages/discovery-details/index', type: 12, show: this.isVicutuProject },

    {
      Name: '限时折扣列表',
      Value: 'pages/standard-product-list/index?type=limitDiscount',
      type: 8
    },
    {
      Name: '预售列表',
      Value: 'pages/special-topic/index?type=preSales',
      type: 3
    },
    {
      Name: '拼团列表',
      Value: 'pages/special-topic/index?type=group',
      type: 2
    },
    {
      Name: '秒杀列表',
      Value: 'pages/special-topic/index?type=secKill',
      type: 4
    },
    {
      Name: '满X件免一列表',
      Value: 'pages/standard-product-list/index?type=buyGetOne',
      type: 5,
      show: this.isVicutuProject
    },
    {
      Name: '满减满折列表',
      Value: 'pages/standard-product-list/index?type=tierDiscount',
      type: 6
    },
    {
      Name: '满包邮列表',
      Value: 'pages/standard-product-list/index?type=freeShipping',
      type: 7,
      show: this.isVicutuProject
    },
    {
      Name: '商品打包',
      Value: 'pages/standard-product-list/index?type=productPack',
      type: 18,
      // show: this.isEveProject
    },
    {
      Name: '套装分组',
      Value: 'pages/set-activity/index?type=outfit',
      type: 19,
      // show: this.isEveProject
    },
    {
      Name: '满送活动',
      Value: 'pages/standard-product-list/index?type=buyGetGiveaway',
      type: 20,
      // show: this.isEveProject
    },
    {
      Name: '买一送一',
      Value: 'pages/standard-product-list/index?type=buyGetOne',
      type: 23,
      // show: this.isEveProject
    },
    {
      Name: '第2件半价',
      Value: 'pages/standard-product-list/index?type=halfPrice',
      type: 24,
      // show: this.isEveProject
    },
    {
      Name: '买送券',
      Value: 'pages/standard-product-list/index?type=fullGetCoupons',
      type: 25,
      // show: this.isEveProject
    },

    { Name: '大转盘', Value: 'pages/luckdraw/luckdraw', type: 9 },
    { Name: '刮刮乐', Value: 'pages/scratch/index', type: 10 },
    { Name: '微页面', Value: 'pages/diy/index', type: 13 },

    { Name: '助力领券', Value: 'pages/help-get-coupon/index', type: 14, show: this.isVicutuProject },
    { Name: '限时购券', Value: 'pages/buy-coupon/index', type: 15, show: this.isVicutuProject },
    {
      Name: '抢优惠券',
      Value: 'pages/grab-coupons/index',
      type: 21,
      // show: this.isEveProject
    },
    {
      Name: '优惠券',
      Value: 'pages/coupon-details/index',
      type: 26,
      // show: this.isEveProject
    },
    {
      Name: '套装',
      Value: 'pages/packaged-goods/index',
      type: 22,
      // show: this.isEveProject
    }
  ]

  get showUrlList() {
    return this.MallUrlListConfig.filter(item => item.type == 0)
  }

  created() {
    if (this.$route.query.test) {
      this.MallUrlListSubmit()
    } else {
      this.getConfig()
    }
    // this.MallUrlListSubmit()
  }

  /**
   * 获取设置
   */
  getConfig() {
    MallConfig.getMallConfig('MallUrlListConfig').then(res => {
      if (res.data.UrlItems) {
        this.MallUrlListConfig = res.data.UrlItems
      } else {
        this.MallUrlListSubmit()
      }
    })
  }

  /**
   * 复制路径
   */
  copyFn(item) { }

  // 复制成功时的回调函数
  onCopy(e) {
    let Message: any = this.$Message
    Message.success({
      background: true,
      content: '内容已复制到剪切板！'
    })
  }
  // 复制失败时的回调函数
  onError(e) {
    let Message: any = this.$Message
    Message.error({
      background: true,
      content: '抱歉，复制失败！'
    })
  }

  /**
   * 商城路径设置
   */
  MallUrlListSubmit() {
    let vm = this
    const lastMallUrlListConfig = []
    this.MallUrlListConfig.forEach(item => {
      if (item.hasOwnProperty('show')) {
        if (item.show) {
          lastMallUrlListConfig.push(item)
        }
      } else {
        lastMallUrlListConfig.push(item)
      }
    })
    let value = {
      UrlItems: lastMallUrlListConfig
    }
    MallConfig.updateMallConfig(
      'MallUrlListConfig',
      '商城路径设置',
      value
    ).then(res => {
      vm.$Notice.success({
        desc: '提交成功'
      })
      vm.getConfig()
    })
  }
}
